import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ScreenOrientation } from './kiosk-tile-content.component';

export const useKioskTileContentStyles = makeStyles<Theme, { kioskScreenOrientation: ScreenOrientation }>({
  root: {
    height: '100%'
  },
  kioskLight: {
    // 2px x 2px solid black circle
    background: '#000',
    borderRadius: '50%',
    height: '4px',
    width: '4px',
    marginBottom: '8px'
  },
  kioskScreen: {
    // light grey background with grey border
    background: '#f2f2f2',
    border: '1px solid #ccc',
    height: ({ kioskScreenOrientation }) => (kioskScreenOrientation === ScreenOrientation.Portrait ? '90px' : '70px'),
    width: ({ kioskScreenOrientation }) => (kioskScreenOrientation === ScreenOrientation.Portrait ? '70px' : '90px'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  kioskScanner: {
    // 5px x 3px solid black rectangle
    background: '#000',
    border: '3px solid #000',
    height: '5px',
    width: '14px',
    marginTop: '12px'
  },
  icon: {
    width: '40px'
  }
});
